var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBauversorgung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 330,
    viewBox: "0 0 457 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bauversorgung"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M239.258 327.174L236.773 328.696L0.253693 191.818V172.946L5.56593 171.216L236.773 280.014L239.258 327.174Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.815 329.093L0.22757 192.497V189.345L236.815 326.182V329.093Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 427",
    d: "M451.111 186.783L348.327 236.625L340.721 252.522L348.327 258.964L456.769 199.094V189.708L451.111 186.783Z",
    fill: "#7A6957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.772 202.347L236.814 329.094L236.814 297.858L348.325 242.823V253.125L456.772 189.704V202.347Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.240585 172.954L236.804 310.399L432.796 196.969L366.223 140.262V134.914L219.369 58.1536L0.240585 172.954Z",
    fill: "#65813F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 18",
    d: "M260.877 78.9658L39.8224 199.002L108.375 236.284L332.007 116.975L260.877 78.9658Z",
    fill: "#64605F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 19",
    d: "M239.535 68.6155L19.23 184.029L40.0652 196.209L261.415 79.2533L239.535 68.6155Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 20",
    d: "M261.4 79.2556L40.0471 196.199V198.904L264.483 80.8926L261.4 79.2556Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M329.047 244.661C293.038 247.844 248.026 207.177 265.199 180.498C276.046 163.646 359.126 140.258 366.221 140.258L456.771 189.708L348.318 245.847C342.723 245.358 335.398 244.1 329.047 244.661Z",
    fill: "#7A6957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M270.857 177.23C274.659 174.313 278.609 174.439 288.761 170.516C291.967 169.278 321.846 155.717 321.846 155.717C321.846 155.717 310.612 162.385 306.35 164.783C302.63 166.875 285.983 173.705 283.24 181.748C279.038 194.072 280.628 201.13 289.835 214.756C299.962 229.744 311.433 241.639 336.465 244.634C334.513 244.464 331.503 244.534 331.137 244.534C330.804 244.534 327.981 244.817 324.001 244.817C321.065 244.817 305.424 244.549 287.461 232.028C270.093 219.922 266.8 210.498 264.5 206.117C262.199 201.736 262.632 199.649 262.955 195.546C263.42 189.629 266.101 182.996 270.857 177.23Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M267.68 212.135C245.57 178.403 287.126 161.427 294.757 158.227C302.388 155.026 325.761 147.351 366.221 134.883V140.266C352.47 145.212 337.351 149.467 319.472 157.172C272.485 175.54 257.11 189.604 267.68 212.135Z",
    fill: "#574A3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 414",
    d: "M236.313 244.756L265.386 227.002L305.781 246.772L274.671 266.336L271.902 264.965L276.15 261.856L241.643 243.618L238.224 245.898L236.313 244.756Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M66.2748 154.484C74.7191 157.968 74.7191 163.716 66.2748 167.35C56.763 170.909 45.5097 170.909 35.9996 167.35C27.5571 163.867 27.5571 158.118 35.9996 154.484C45.5097 150.925 56.763 150.925 66.2748 154.484Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M50.6679 160.661L46.1658 133.605C46.2738 134.71 45.7234 135.551 44.5139 136.311C42.2232 137.752 38.4261 137.95 36.0336 136.686C34.7905 136.03 34.1728 135.165 34.1854 134.259L34.1824 134.259L31.4692 162.489C31.3271 164.081 32.3348 165.652 34.4765 166.784C38.3845 168.849 44.5875 168.587 48.3292 166.234C50.829 164.662 51.5956 162.511 50.6679 160.661Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M29.8869 82.3953C42.4057 82.3953 52.5547 92.8616 52.5547 105.771C52.5547 118.681 42.4057 129.147 29.8869 129.147C17.3673 129.147 7.21918 118.681 7.21918 105.771C7.21918 92.8616 17.3673 82.3953 29.8869 82.3953Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M42.6841 100.362C35.2232 104.45 23.1354 104.45 15.6744 100.362C12.2741 98.5451 10.4798 96.0922 10.102 93.7291C9.72353 96.7282 11.5187 99.7251 15.6744 101.997C23.1354 106.085 35.2232 106.085 42.6841 101.997C46.7464 99.7251 48.635 96.7267 48.2573 93.7291C47.8788 96.182 46.086 98.5412 42.6841 100.362Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M44.6849 116.775C36.1186 121.375 22.24 121.375 13.6737 116.775C9.76967 114.731 7.70947 111.972 7.2758 109.313C6.8412 112.687 8.90232 116.059 13.6737 118.614C22.24 123.214 36.1186 123.214 44.6849 118.614C49.349 116.059 51.5173 112.686 51.0837 109.313C50.6491 112.073 48.5907 114.727 44.6849 116.775Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M49.7214 93.7291C62.2402 93.7291 72.3892 104.196 72.3892 117.105C72.3892 130.015 62.2402 140.481 49.7214 140.481C37.2018 140.481 27.0537 130.015 27.0537 117.105C27.0537 104.196 37.2018 93.7291 49.7214 93.7291Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M63.7272 111.696C55.9899 115.784 43.4544 115.784 35.7171 111.696C32.1909 109.879 30.3301 107.426 29.9384 105.063C29.5459 108.062 31.4075 111.059 35.7171 113.331C43.4544 117.419 55.9899 117.419 63.7272 113.331C67.94 111.059 69.8985 108.061 69.5068 105.063C69.1143 107.516 67.2551 109.875 63.7272 111.696Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M65.936 128.109C57.3697 132.708 43.4911 132.708 34.9248 128.109C31.0208 126.065 28.9606 123.306 28.5269 120.647C28.0923 124.021 30.1534 127.393 34.9248 129.948C43.4911 134.548 57.3697 134.548 65.936 129.948C70.6001 127.393 72.7685 124.019 72.3348 120.647C71.9002 123.407 69.8418 126.061 65.936 128.109Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M29.8873 113.563C38.494 113.563 45.4714 120.858 45.4714 129.856C45.4714 138.853 38.494 146.148 29.8873 146.148C21.2801 146.148 14.3033 138.853 14.3033 129.856C14.3033 120.858 21.2801 113.563 29.8873 113.563Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M38.6827 127.038C33.4324 130.105 24.9261 130.105 19.6758 127.038C17.2831 125.676 16.0204 123.836 15.7546 122.064C15.4882 124.313 16.7515 126.561 19.6758 128.264C24.9261 131.331 33.4324 131.331 38.6827 128.264C41.5413 126.561 42.8703 124.312 42.6045 122.064C42.3382 123.904 41.0766 125.673 38.6827 127.038Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M40.8918 138.372C34.8125 141.439 24.9632 141.439 18.8839 138.372C16.1133 137.01 14.6512 135.17 14.3434 133.398C14.035 135.647 15.4977 137.895 18.8839 139.598C24.9632 142.665 34.8125 142.665 40.8918 139.598C44.2018 137.895 45.7407 135.646 45.4329 133.398C45.1245 135.237 43.6637 137.007 40.8918 138.372Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M147.754 111.826C156.198 115.311 156.198 121.059 147.754 124.693C138.242 128.252 126.988 128.252 117.478 124.693C109.036 121.21 109.036 115.46 117.478 111.826C126.988 108.268 138.242 108.268 147.754 111.826Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M132.147 118.004L127.645 90.9482C127.752 92.0525 127.202 92.8936 125.993 93.6539C123.702 95.0943 119.905 95.293 117.512 94.0289C116.269 93.373 115.651 92.5081 115.664 91.6013L115.661 91.6014L112.948 119.832C112.806 121.424 113.813 122.995 115.955 124.127C119.863 126.192 126.066 125.929 129.808 123.576C132.308 122.004 133.074 119.854 132.147 118.004Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M111.366 39.7379C123.884 39.7379 134.033 50.2043 134.033 63.114C134.033 76.0238 123.884 86.4901 111.366 86.4901C98.846 86.4901 88.6979 76.0238 88.6979 63.114C88.6979 50.2043 98.846 39.7379 111.366 39.7379Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M124.163 57.7047C116.702 61.7931 104.614 61.7931 97.1531 57.7047C93.7528 55.8878 91.9585 53.4349 91.5807 51.0719C91.2022 54.071 92.9974 57.0678 97.1531 59.3394C104.614 63.4279 116.702 63.4279 124.163 59.3394C128.225 57.0678 130.114 54.0695 129.736 51.0719C129.357 53.5248 127.565 55.884 124.163 57.7047Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M126.164 74.1178C117.597 78.7173 103.719 78.7173 95.1524 74.1178C91.2484 72.0738 89.1882 69.3143 88.7545 66.6559C88.3199 70.0299 90.381 73.4013 95.1524 75.9569C103.719 80.5564 117.597 80.5564 126.164 75.9569C130.828 73.4013 132.996 70.0282 132.562 66.6559C132.128 69.4154 130.069 72.0695 126.164 74.1178Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M131.2 51.0719C143.719 51.0719 153.868 61.5383 153.868 74.448C153.868 87.3577 143.719 97.8241 131.2 97.8241C118.681 97.8241 108.532 87.3577 108.532 74.448C108.532 61.5383 118.681 51.0719 131.2 51.0719Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M145.206 69.0385C137.469 73.127 124.933 73.127 117.196 69.0385C113.67 67.2217 111.809 64.7688 111.417 62.4058C111.025 65.4049 112.886 68.4017 117.196 70.6733C124.933 74.7617 137.469 74.7617 145.206 70.6733C149.419 68.4017 151.377 65.4033 150.985 62.4058C150.593 64.8587 148.734 67.2179 145.206 69.0385Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M147.415 85.4517C138.848 90.0512 124.97 90.0512 116.403 85.4517C112.499 83.4078 110.439 80.6483 110.006 77.9899C109.571 81.3639 111.632 84.7353 116.403 87.2909C124.97 91.8904 138.848 91.8904 147.415 87.2909C152.079 84.7353 154.247 81.3621 153.813 77.9899C153.379 80.7494 151.321 83.4035 147.415 85.4517Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M111.366 70.9061C119.973 70.9061 126.95 78.2009 126.95 87.1986C126.95 96.1963 119.973 103.491 111.366 103.491C102.759 103.491 95.7819 96.1963 95.7819 87.1986C95.7819 78.2009 102.759 70.9061 111.366 70.9061Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M120.161 84.3811C114.911 87.4474 106.405 87.4474 101.155 84.3811C98.7617 83.0185 97.499 81.1788 97.2332 79.4065C96.9669 81.6558 98.2301 83.9034 101.155 85.6071C106.405 88.6735 114.911 88.6735 120.161 85.6071C123.02 83.9034 124.349 81.6547 124.083 79.4065C123.817 81.2462 122.555 83.0156 120.161 84.3811Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M122.37 95.7151C116.291 98.7814 106.442 98.7814 100.363 95.7151C97.592 94.3524 96.1299 92.5128 95.8221 90.7405C95.5137 92.9898 96.9764 95.2374 100.363 96.9411C106.442 100.007 116.291 100.007 122.37 96.9411C125.68 95.2374 127.219 92.9887 126.912 90.7405C126.603 92.5802 125.142 94.3496 122.37 95.7151Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M222.848 72.994C231.292 76.4782 231.292 82.2267 222.848 85.8607C213.336 89.4191 202.083 89.4191 192.573 85.8607C184.13 82.3778 184.13 76.628 192.573 72.994C202.083 69.4356 213.336 69.4356 222.848 72.994Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M207.241 79.1714L202.739 52.1158C202.847 53.2201 202.296 54.0612 201.087 54.8215C198.796 56.2619 194.999 56.4606 192.607 55.1965C191.364 54.5406 190.746 53.6757 190.758 52.7689L190.755 52.769L188.042 80.9995C187.9 82.5913 188.908 84.1623 191.05 85.2941C194.958 87.3592 201.161 87.097 204.902 84.7439C207.402 83.172 208.169 81.0214 207.241 79.1714Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M186.46 0.90564C198.979 0.90564 209.128 11.372 209.128 24.2818C209.128 37.1915 198.979 47.6579 186.46 47.6579C173.94 47.6579 163.792 37.1915 163.792 24.2818C163.792 11.372 173.94 0.90564 186.46 0.90564Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M199.257 18.8723C191.796 22.9607 179.708 22.9607 172.247 18.8723C168.847 17.0554 167.053 14.6025 166.675 12.2395C166.297 15.2386 168.092 18.2354 172.247 20.507C179.708 24.5955 191.796 24.5955 199.257 20.507C203.319 18.2354 205.208 15.2371 204.83 12.2395C204.452 14.6924 202.659 17.0516 199.257 18.8723Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M201.258 35.2855C192.692 39.885 178.813 39.885 170.247 35.2855C166.343 33.2415 164.283 30.482 163.849 27.8236C163.414 31.1976 165.475 34.569 170.247 37.1246C178.813 41.7241 192.692 41.7241 201.258 37.1246C205.922 34.569 208.09 31.1959 207.657 27.8236C207.222 30.5831 205.164 33.2372 201.258 35.2855Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M206.295 12.2395C218.813 12.2395 228.962 22.7059 228.962 35.6156C228.962 48.5253 218.813 58.9917 206.295 58.9917C193.775 58.9917 183.627 48.5253 183.627 35.6156C183.627 22.7059 193.775 12.2395 206.295 12.2395Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M220.3 30.2061C212.563 34.2946 200.027 34.2946 192.29 30.2061C188.764 28.3893 186.903 25.9364 186.511 23.5734C186.119 26.5725 187.981 29.5693 192.29 31.8409C200.027 35.9293 212.563 35.9293 220.3 31.8409C224.513 29.5693 226.472 26.5709 226.08 23.5734C225.687 26.0263 223.828 28.3855 220.3 30.2061Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M222.509 46.6193C213.943 51.2188 200.064 51.2188 191.498 46.6193C187.594 44.5754 185.534 41.8159 185.1 39.1575C184.665 42.5315 186.726 45.9029 191.498 48.4585C200.064 53.058 213.943 53.058 222.509 48.4585C227.173 45.9029 229.342 42.5297 228.908 39.1575C228.473 41.917 226.415 44.5711 222.509 46.6193Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M186.46 32.0737C195.067 32.0737 202.044 39.3685 202.044 48.3662C202.044 57.3639 195.067 64.6586 186.46 64.6586C177.853 64.6586 170.876 57.3639 170.876 48.3662C170.876 39.3685 177.853 32.0737 186.46 32.0737Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M195.256 45.5488C190.005 48.6151 181.499 48.6151 176.249 45.5488C173.856 44.1862 172.593 42.3465 172.328 40.5742C172.061 42.8236 173.325 45.0712 176.249 46.7749C181.499 49.8412 190.005 49.8412 195.256 46.7749C198.114 45.0712 199.443 42.8224 199.178 40.5742C198.911 42.4139 197.65 44.1833 195.256 45.5488Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M197.465 56.8827C191.386 59.949 181.536 59.949 175.457 56.8827C172.686 55.52 171.224 53.6804 170.917 51.9081C170.608 54.1574 172.071 56.405 175.457 58.1087C181.536 61.1751 191.386 61.1751 197.465 58.1087C200.775 56.405 202.314 54.1563 202.006 51.9081C201.698 53.7478 200.237 55.5172 197.465 56.8827Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M185.505 90.6576C188.636 92.4153 188.636 95.3153 185.505 97.1486C181.978 98.9437 177.805 98.9437 174.279 97.1486C171.148 95.3915 171.148 92.4909 174.279 90.6576C177.805 88.8625 181.978 88.8625 185.505 90.6576Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M177.714 74.1608C183.535 74.1608 188.253 79.0845 188.253 85.1583C188.253 91.2321 183.535 96.1558 177.714 96.1558C171.893 96.1558 167.175 91.2321 167.175 85.1583C167.175 79.0845 171.893 74.1608 177.714 74.1608Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M185.274 89.8176C180.565 92.1842 175.013 92.1842 170.305 89.8176C168.164 88.5952 167.175 86.9918 167.175 85.3878C167.009 87.6253 168.217 89.7401 170.229 90.7332C174.937 93.1005 180.488 93.1005 185.197 90.7332C186.939 89.7485 188.104 87.9876 188.328 85.9987C187.932 87.664 186.811 89.0653 185.274 89.8176Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M184.203 83.0198C180.121 85.0823 175.302 85.0823 171.22 83.0198C169.853 82.3793 168.863 81.1356 168.547 79.6594C168.317 81.1104 169.235 82.633 171.22 83.7837C175.302 85.8462 180.121 85.8462 184.203 83.7837C186.188 82.6376 187.028 81.1104 186.875 79.6594C186.58 81.1459 185.585 82.3973 184.203 83.0198Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M94.2744 135.047C98.049 137.166 98.049 140.662 94.2744 142.872C90.0227 145.036 84.9926 145.036 80.7417 142.872C76.9679 140.754 76.9679 137.257 80.7417 135.047C84.9926 132.883 90.0227 132.883 94.2744 135.047Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M84.8827 115.161C91.8993 115.161 97.5872 121.096 97.5872 128.418C97.5872 135.74 91.8993 141.675 84.8827 141.675C77.8652 141.675 72.1781 135.74 72.1781 128.418C72.1781 121.096 77.8652 115.161 84.8827 115.161Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M93.9958 134.035C88.3196 136.888 81.6267 136.888 75.9513 134.035C73.3701 132.561 72.1783 130.628 72.1783 128.695C71.9783 131.392 73.4339 133.941 75.8594 135.138C81.5349 137.992 88.2269 137.992 93.9032 135.138C96.0026 133.951 97.4068 131.829 97.6777 129.431C97.2005 131.439 95.8492 133.128 93.9958 134.035Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M92.7045 125.84C87.7841 128.326 81.9748 128.326 77.0544 125.84C75.4057 125.068 74.2132 123.569 73.8318 121.789C73.5546 123.538 74.6608 125.374 77.0544 126.761C81.9748 129.247 87.7841 129.247 92.7045 126.761C95.0974 125.379 96.1101 123.538 95.9264 121.789C95.5706 123.581 94.3703 125.09 92.7045 125.84Z",
    fill: "#D9D9D0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bagger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kette Rechts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.533 119.771L265.751 147.38C265.751 147.38 270.59 149.886 270.289 156.455C270.081 161.011 265.751 159.149 265.751 159.149L218.533 131.541C218.533 131.541 215.357 130.048 215.357 123.766C215.357 117.983 218.533 119.771 218.533 119.771Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.533 119.771L265.751 147.38C265.751 147.38 270.59 149.886 270.289 156.455C270.081 161.011 265.751 159.149 265.751 159.149L218.533 131.541C218.533 131.541 215.357 130.048 215.357 123.766C215.357 117.983 218.533 119.771 218.533 119.771Z",
    fill: "#494949"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 273",
    d: "M266.86 153.889L253.974 162.371L256.641 166.644L269.007 159.191L266.86 153.889Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 274",
    d: "M216.909 119.429L204.691 126.85L255.038 162.805L267.522 155.002L216.909 119.429Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 271"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.678 126.836L254.296 155.275C254.296 155.275 258.029 156.776 258.029 163.353C258.029 167.372 255.22 167.167 254.296 166.738C253.373 166.308 206.678 138.605 206.678 138.605C206.678 138.605 203.501 137.112 203.501 130.831C203.501 125.047 206.678 126.836 206.678 126.836Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.678 126.836L254.296 155.275C254.296 155.275 258.029 156.776 258.029 163.353C258.029 167.372 255.22 167.167 254.296 166.738C253.373 166.308 206.678 138.605 206.678 138.605C206.678 138.605 203.501 137.112 203.501 130.831C203.501 125.047 206.678 126.836 206.678 126.836Z",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 277"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.091 127.908L253.871 156.004C253.871 156.004 257.061 157.288 257.061 162.91C257.061 166.346 254.66 166.171 253.871 165.804C253.081 165.437 207.091 137.97 207.091 137.97C207.091 137.97 204.376 136.693 204.376 131.323C204.375 126.379 207.091 127.908 207.091 127.908Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.091 127.908L253.871 156.004C253.871 156.004 257.061 157.288 257.061 162.91C257.061 166.346 254.66 166.171 253.871 165.804C253.081 165.437 207.091 137.97 207.091 137.97C207.091 137.97 204.376 136.693 204.376 131.323C204.375 126.379 207.091 127.908 207.091 127.908Z",
    fill: "#343434"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 306",
    d: "M256.317 160.913C256.317 155.799 252.55 155.05 252.55 155.05L253.016 164.106C253.734 164.441 256.317 164.038 256.317 160.913Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 277_2",
    d: "M255.47 161.338C255.47 156.223 252.567 155.056 252.567 155.056V163.97C253.285 164.304 255.47 164.463 255.47 161.338Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 305",
    d: "M249.665 157.687C249.665 162.802 252.567 163.969 252.567 163.969V155.055C251.849 154.721 249.665 154.562 249.665 157.687Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 308",
    d: "M247.019 155.945C247.019 150.83 243.252 150.081 243.252 150.081L243.718 159.138C244.436 159.472 247.019 159.07 247.019 155.945Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 309",
    d: "M246.172 156.369C246.172 151.255 243.269 150.087 243.269 150.087V159.002C243.987 159.336 246.172 159.495 246.172 156.369Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 310",
    d: "M240.367 152.719C240.367 157.833 243.269 159.001 243.269 159.001V150.087C242.551 149.752 240.367 149.593 240.367 152.719Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 311",
    d: "M237.913 150.405C237.913 145.29 234.147 144.541 234.147 144.541L234.612 153.598C235.33 153.932 237.913 153.53 237.913 150.405Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 312",
    d: "M237.067 150.829C237.067 145.715 234.164 144.547 234.164 144.547V153.462C234.882 153.796 237.067 153.955 237.067 150.829Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 313",
    d: "M231.262 147.179C231.262 152.293 234.164 153.461 234.164 153.461V144.547C233.446 144.213 231.262 144.054 231.262 147.179Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 314",
    d: "M229.181 145.547C229.181 140.433 225.415 139.684 225.415 139.684L225.881 148.741C226.599 149.075 229.181 148.673 229.181 145.547Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 315",
    d: "M228.334 145.972C228.334 140.857 225.432 139.69 225.432 139.69V148.604C226.15 148.938 228.334 149.097 228.334 145.972Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 316",
    d: "M222.53 142.321C222.53 147.436 225.432 148.603 225.432 148.603V139.689C224.714 139.355 222.53 139.196 222.53 142.321Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 317",
    d: "M220.449 140.411C220.449 135.296 216.683 134.547 216.683 134.547L217.149 143.604C217.867 143.938 220.449 143.536 220.449 140.411Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 318",
    d: "M219.603 140.835C219.603 135.721 216.7 134.553 216.7 134.553V143.467C217.419 143.802 219.603 143.961 219.603 140.835Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 319",
    d: "M213.798 137.185C213.798 142.299 216.7 143.467 216.7 143.467V134.553C215.982 134.218 213.798 134.059 213.798 137.185Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 320",
    d: "M212.285 135.166C212.285 130.052 208.519 129.303 208.519 129.303L208.985 138.359C209.703 138.694 212.285 138.291 212.285 135.166Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 321",
    d: "M211.438 135.591C211.438 130.477 208.536 129.309 208.536 129.309V138.223C209.254 138.557 211.438 138.716 211.438 135.591Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 322",
    d: "M205.634 131.94C205.634 137.055 208.536 138.222 208.536 138.222V129.308C207.818 128.974 205.634 128.815 205.634 131.94Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 307",
    d: "M255.4 156.185L250.875 153.458L250.573 154.008L255.4 156.653L255.4 156.185Z",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Kette Rechts_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 276_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.75 99.7853L298.967 127.394C298.967 127.394 303.806 129.899 303.506 136.469C303.297 141.025 298.967 139.163 298.967 139.163L251.75 111.554C251.75 111.554 248.574 110.062 248.574 103.78C248.574 97.9968 251.75 99.7853 251.75 99.7853Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.75 99.7853L298.967 127.394C298.967 127.394 303.806 129.899 303.506 136.469C303.297 141.025 298.967 139.163 298.967 139.163L251.75 111.554C251.75 111.554 248.574 110.062 248.574 103.78C248.574 97.9968 251.75 99.7853 251.75 99.7853Z",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 273_2",
    d: "M300.077 133.903L287.191 142.385L289.946 146.668L302.224 139.205L300.077 133.903Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 274_2",
    d: "M249.934 99.6183L237.716 107.039L288.254 142.819L300.739 135.016L249.934 99.6183Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 271_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.894 106.85L287.112 134.458C287.112 134.458 290.844 135.96 290.844 142.536C290.844 146.555 288.035 146.351 287.112 145.921C286.188 145.491 239.894 118.619 239.894 118.619C239.894 118.619 236.718 117.126 236.718 110.845C236.718 105.061 239.894 106.85 239.894 106.85Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 106.85L287.112 134.458C287.112 134.458 290.844 135.96 290.844 142.536C290.844 146.555 288.035 146.351 287.112 145.921C286.188 145.491 239.894 118.619 239.894 118.619C239.894 118.619 236.718 117.126 236.718 110.845C236.718 105.061 239.894 106.85 239.894 106.85Z",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 275"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.883 107.051L287.101 134.659C287.101 134.659 291.94 137.165 291.639 143.735C291.431 148.29 287.101 146.428 287.101 146.428L239.883 118.82C239.883 118.82 236.707 117.327 236.707 111.046C236.707 105.262 239.883 107.051 239.883 107.051Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.883 107.051L287.101 134.659C287.101 134.659 291.94 137.165 291.639 143.735C291.431 148.29 287.101 146.428 287.101 146.428L239.883 118.82C239.883 118.82 236.707 117.327 236.707 111.046C236.707 105.262 239.883 107.051 239.883 107.051Z",
    fill: "#454545"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 412",
    d: "M245.434 95.927L265.316 81.3414L340.563 121.846L317.718 136.217L331.991 135.8L306.286 148.586L266.212 169.1L254.9 166.696L245.434 95.927Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 413",
    d: "M317.723 136.2L332.051 127.197L357.114 130.231L366.256 134.912L317.723 136.2Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 263"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.194 100.268L301.246 111.88L267.857 131.147L247.806 119.535L281.194 100.268Z",
    fill: "#CBC8BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.194 100.268L301.246 111.88L267.857 131.147L247.806 119.535L281.194 100.268Z",
    fill: "#CBC8BC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 264"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.379 79.1965L301.448 111.874L294.825 115.708L240.755 83.0303L247.379 79.1965Z",
    fill: "#CBC8BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.379 79.1965L301.448 111.874L294.825 115.708L240.755 83.0303L247.379 79.1965Z",
    fill: "#CBC8BC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-arm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 277_3",
    d: "M313.663 71.4127L299.547 80.3833L280.709 119.85L294.96 110.663L313.663 71.4127Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 276_3",
    d: "M288.913 74.3113L266.347 109.613L280.723 119.843L299.556 80.3845L288.913 74.3113Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 278",
    d: "M312.201 66.3603L310.384 67.0214L299 65.116L288.91 74.311L288.642 82.1671L299.547 80.3771L314.179 74.7272L321.572 69.904L312.201 66.3603Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 280",
    d: "M299.025 62.5692L291.24 67.2992L288.922 74.3115L304.082 69.2312L299.025 62.5692Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 281",
    d: "M303.967 61.4481L299.015 62.5682L303.967 69.2078L310.331 67.0537L303.967 61.4481Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 279",
    d: "M349.339 67.9051L331.077 65.9802L312.196 66.3627L314.037 74.7126L349.339 72.3202V67.9051Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 277_4",
    d: "M352.869 66.3598L317.098 65.3455L312.193 66.3598L349.338 67.9051L352.869 66.3598Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 287",
    d: "M329.121 62.0818C329.121 62.0818 328.033 62.1658 327.878 60.6787C327.722 59.1915 328.623 59.0439 328.623 59.0439L303.528 62.8247C303.528 62.8247 302.467 62.9092 302.712 64.3757C302.958 65.8423 304.027 65.8626 304.027 65.8626L329.121 62.0818Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 60",
    rx: 1.55409,
    ry: 1.17289,
    transform: "matrix(-0.222866 -0.974849 -0.974849 0.222866 328.851 60.5472)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 288",
    d: "M328.928 59.9499L348.807 57.1239L348.154 58.5504L329.117 61.1134C329.117 61.1134 328.523 61.1698 328.427 60.6085C328.332 60.0473 328.928 59.9499 328.928 59.9499Z",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b-arm-Gruppe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schaufel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 298",
    d: "M368.785 115.157L354.276 123.445L350.982 137.614L367.498 127.502L368.785 115.157Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 36",
    d: "M351.757 110.84L350.982 111.499L351.537 113.79L353.598 121.877C353.598 121.877 354.193 126.256 358.518 128.581C362.843 130.906 366.439 128.187 366.439 128.187L369.78 114.15C369.834 114.11 369.863 114.088 369.863 114.088L369.784 114.132L369.78 114.15C369.162 114.61 365.221 117.445 362.002 117.491C358.076 117.547 352.949 113.118 352.949 113.118L351.757 110.84Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M368.781 126.096V115.161C368.781 115.161 365.215 118.337 361.712 118.387C357.786 118.443 352.659 114.014 352.659 114.014L351.45 111.102L350.675 111.761L353.308 122.773C353.308 122.773 353.902 127.152 358.228 129.477C362.553 131.802 368.781 126.096 368.781 126.096Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 300",
    d: "M351.253 114.209L336.945 122.76L346.685 131.845L358.715 121.27C358.715 121.27 356.92 121.218 355.303 120.047C353.237 118.551 351.253 114.209 351.253 114.209Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 299",
    d: "M371.538 114.694L356.459 124.291L353.004 136.379L369.121 126.475L371.538 114.694Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 301",
    d: "M368.864 114.081L354.274 123.42L356.459 124.295L371.547 114.686L368.864 114.081Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M337.79 119.279L337.015 119.938L337.273 121.632L337.915 123.125L339.327 122.454L337.79 119.279Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 22_2",
    d: "M339.782 118.09L339.008 118.749L339.246 120.388L339.907 121.936L341.319 121.264L339.782 118.09Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M341.716 116.949L340.941 117.608L341.237 119.348L341.84 120.795L343.252 120.123L341.716 116.949Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 24",
    d: "M343.639 115.785L342.864 116.444L343.094 118.202L343.764 119.631L345.176 118.96L343.639 115.785Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M342.863 116.442L342.895 116.712L343.136 119.078L343.36 118.936L343.542 118.819L342.863 116.442Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 32",
    d: "M344.812 115.277L344.844 115.548L345.085 117.914L345.309 117.772L345.491 117.655L345.618 116.522L344.812 115.277Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M346.674 114.17L346.706 114.44L346.947 116.806L347.171 116.664L347.353 116.547L347.494 115.171L346.674 114.17Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M348.671 112.971L348.703 113.242L348.943 115.608L349.168 115.465L349.35 115.348L349.547 114.042L348.671 112.971Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 29",
    d: "M340.94 117.61L340.972 117.881L341.212 120.247L341.437 120.104L341.619 119.987L340.94 117.61Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 30",
    d: "M339.007 118.744L339.039 119.015L339.28 121.381L339.505 121.238L339.686 121.121L339.007 118.744Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 31",
    d: "M337.016 119.937L337.047 120.208L337.282 122.56L337.513 122.431L337.694 122.315L337.016 119.937Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M345.587 114.628L344.812 115.287L345.712 118.474L347.124 117.802L345.587 114.628Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M347.449 113.515L346.674 114.174L347.573 117.362L348.985 116.69L347.449 113.515Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M349.446 112.325L348.671 112.984L349.57 116.171L350.982 115.5L349.446 112.325Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 302",
    d: "M356.458 124.294L354.277 123.419L350.994 137.604L353.008 136.373L356.458 124.294Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 298_2",
    d: "M367.587 112.326C367.587 111.553 367.175 110.838 366.505 110.451V110.451C365.061 109.617 363.256 110.659 363.256 112.326V116.003C363.256 116.777 363.669 117.492 364.339 117.879V117.879C365.783 118.712 367.587 117.67 367.587 116.003V112.326Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 299_2",
    d: "M367.034 112.423C367.034 111.649 366.621 110.934 365.951 110.547V110.547C364.508 109.714 362.703 110.756 362.703 112.423V116.099C362.703 116.873 363.116 117.588 363.786 117.975V117.975C365.23 118.808 367.034 117.766 367.034 116.099V112.423Z",
    fill: "#928D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 35",
    d: "M336.251 120.124L335.476 120.783L336.031 123.074L338.092 131.161C338.092 131.161 338.686 135.54 343.012 137.865C347.337 140.19 350.933 137.471 350.933 137.471L354.274 123.434C354.328 123.394 354.357 123.372 354.357 123.372L354.278 123.416L354.274 123.434C353.656 123.894 349.715 126.729 346.496 126.775C342.57 126.831 337.443 122.402 337.443 122.402L336.251 120.124Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21_2",
    d: "M350.993 137.607L354.284 123.416C354.284 123.416 349.615 127.067 346.112 127.117C342.186 127.173 337.059 122.744 337.059 122.744L335.867 120.466L335.092 121.125L335.647 123.416L337.708 131.503C337.708 131.503 338.302 135.882 342.628 138.207C346.953 140.532 350.993 137.607 350.993 137.607Z",
    fill: "#928D8D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b-arm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 284",
    d: "M345.16 65.0358L357.054 116.389L360.743 118.766V72.0512L349.533 55.5472L345.16 65.0358Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 282",
    d: "M365.627 69.8119L360.742 72.195L360.742 118.763L365.627 114.984V69.8119Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 283",
    d: "M354.495 53.2278L349.539 55.5535L360.743 72.3494L365.652 69.7885L354.495 53.2278Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 291",
    d: "M367.91 115.802L363.022 118.62V120.026L367.91 117.208V115.802Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 292",
    d: "M358.453 115.958L363.022 118.62V120.025L358.453 117.364V115.958Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 293"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.605 114.516L367.917 115.806L363.025 118.619L360.712 117.278L365.605 114.516Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.605 114.516L367.917 115.806L363.025 118.619L360.712 117.278L365.605 114.516Z",
    fill: "#B6B4AC"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 295",
    d: "M363.835 116.49L363.534 98.0848L364.852 98.9354L365.013 116.47C365.013 116.47 365.02 116.864 364.451 116.878C363.882 116.892 363.835 116.49 363.835 116.49Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 294",
    d: "M362.659 100.398C362.659 100.398 362.668 101.355 364.162 101.419C365.656 101.483 365.737 100.349 365.737 100.349L365.668 74.9719C365.668 74.9719 365.74 73.9093 364.253 73.9376C362.766 73.966 362.59 75.0205 362.59 75.0205L362.659 100.398Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 289",
    d: "M367.936 72.1216L363.048 74.9392V76.345L367.936 73.5273V72.1216Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 290",
    d: "M356.073 70.884L363.049 74.9391V76.3448L356.073 72.2898V70.884Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.632 70.8356L367.944 72.1252L363.052 74.9387L360.738 73.5978L365.632 70.8356Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.632 70.8356L367.944 72.1252L363.052 74.9387L360.738 73.5978L365.632 70.8356Z",
    fill: "#B6B4AC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Schaufelaufhaengung"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 296",
    d: "M361.271 116.733C361.271 115.959 360.858 115.244 360.188 114.857V114.857C358.744 114.024 356.939 115.066 356.939 116.733V120.409C356.939 121.183 357.352 121.898 358.022 122.285V122.285C359.466 123.118 361.271 122.076 361.271 120.409V116.733Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 297",
    d: "M360.716 116.829C360.716 116.055 360.303 115.34 359.633 114.954V114.954C358.189 114.12 356.385 115.162 356.385 116.829V120.506C356.385 121.28 356.798 121.995 357.468 122.381V122.381C358.912 123.215 360.716 122.173 360.716 120.506V116.829Z",
    fill: "#928D8D"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Hauptteil"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.414 111.724L261.239 134.982L261.239 150.366L301.414 127.108L301.414 111.724Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.414 111.724L261.239 134.982L261.239 150.366L301.414 127.108L301.414 111.724Z",
    fill: "#8D8A83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 260"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.059 100.119L261.239 134.98L261.239 150.364L201.059 115.503L201.059 100.119Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.059 100.119L261.239 134.98L261.239 150.364L201.059 115.503L201.059 100.119Z",
    fill: "#B6B4AC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 265"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.063 96.7773L202.844 95.6853L221.849 98.1707L227.517 107.818V115.551L201.063 100.148V96.7773Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.063 96.7773L202.844 95.6853L221.849 98.1707L227.517 107.818V115.551L201.063 100.148V96.7773Z",
    fill: "#B6B4AC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 261"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.288 76.4897L260.944 88.6093L227.496 107.798L202.84 95.6789L236.288 76.4897Z",
    fill: "#CBC8BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.288 76.4897L260.944 88.6093L227.496 107.798L202.84 95.6789L236.288 76.4897Z",
    fill: "#CBC8BC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 304"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.671 79.1965L254.424 88.9062L227.627 104.28L207.874 94.5699L234.671 79.1965Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.671 79.1965L254.424 88.9062L227.627 104.28L207.874 94.5699L234.671 79.1965Z",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 305_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.874 94.5692L227.627 104.279L227.627 106.197L207.874 96.4869L207.874 94.5692Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.874 94.5692L227.627 104.279L227.627 106.197L207.874 96.4869L207.874 94.5692Z",
    fill: "#565656"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.848 72.9653L274.74 88.5292L268.841 103.023L254.443 100.282L237.22 98.4772L227.494 84.6779L247.848 72.9653Z",
    fill: "#CBC8BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.848 72.9653L274.74 88.5292L268.841 103.023L254.443 100.282L237.22 98.4772L227.494 84.6779L247.848 72.9653Z",
    fill: "#CBC8BC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.517 115.542L261.214 127.257L261.214 135.185L281.517 123.47L281.517 115.542Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.517 115.542L261.214 127.257L261.214 135.185L281.517 123.47L281.517 115.542Z",
    fill: "#8D8A83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.096 116.398L263.35 126.001L263.35 131.446L280.096 121.843L280.096 116.398Z",
    fill: "#BD8F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.096 116.398L263.35 126.001L263.35 131.446L280.096 121.843L280.096 116.398Z",
    fill: "#BD8F39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.741 88.5295L254.436 100.275L261.215 127.362L281.52 115.617L274.741 88.5295Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.741 88.5295L254.436 100.275L261.215 127.362L281.52 115.617L274.741 88.5295Z",
    fill: "#8D8A83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 266"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.559 91.9204L256.8 101.614L263.35 126.133L280.109 116.44L273.559 91.9204Z",
    fill: "#BD8F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.559 91.9204L256.8 101.614L263.35 126.133L280.109 116.44L273.559 91.9204Z",
    fill: "#BD8F39"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M227.504 115.555V84.6829L254.438 100.279L261.216 127.347V135.194L227.504 115.555Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M230.885 112.932V89.7513L252.412 102.217L258.57 127.28V133.552L237.835 121.451V116.722L230.885 112.932Z",
    fill: "#BD8F39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 268",
    d: "M258.571 127.299L234.36 91.7432L230.884 89.7513L230.875 95.1095L254.748 131.363L258.571 133.58V127.299Z",
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 269",
    d: "M268.788 128.329L274.587 95.8001L273.566 91.9268L269.603 94.121L263.359 126.145L263.359 131.469L268.788 128.329Z",
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 270"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.337 99.3639L203.473 98.6661L218.959 106.004V122.178L202.337 112.459V99.3639Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.337 99.3639L203.473 98.6661L218.959 106.004V122.178L202.337 112.459V99.3639Z",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 325",
    d: "M203.31 98.8476L203.473 98.6641L202.338 99.3639L203.081 99.1L203.31 98.8476Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 324",
    d: "M203.047 112.197L202.618 110.88L202.338 112.462L218.959 122.178L218.959 121.61L203.047 112.197Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 301_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.226 125.961L259.644 151.077L261.9 151.912L305.482 126.796L303.226 125.961Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.226 125.961L259.644 151.077L261.9 151.912L305.482 126.796L303.226 125.961Z",
    fill: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 300_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.491 126.785L261.884 151.921C261.884 151.921 261.921 155.776 261.884 158.912C261.847 162.152 265.344 166.945 265.344 166.945L309.456 141.397C309.456 141.397 305.171 137.32 305.171 134.581C305.171 130.6 305.491 126.785 305.491 126.785Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.491 126.785L261.884 151.921C261.884 151.921 261.921 155.776 261.884 158.912C261.847 162.152 265.344 166.945 265.344 166.945L309.456 141.397C309.456 141.397 305.171 137.32 305.171 134.581C305.171 130.6 305.491 126.785 305.491 126.785Z",
    fill: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 303",
    d: "M261.899 151.912L259.648 151.069V163.043L265.349 166.952C265.349 166.952 261.899 162.043 261.899 159.16C261.899 155.896 261.899 151.912 261.899 151.912Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 323",
    d: "M203.079 99.1007L202.338 99.3646V112.469L203.037 112.207L203.079 99.1007Z",
    fill: "#959595"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Hydrant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M220.19 207.623C236.04 214.162 236.04 224.952 220.19 231.773C202.337 238.452 181.215 238.452 163.365 231.773C147.519 225.235 147.519 214.443 163.365 207.623C181.215 200.944 202.337 200.944 220.19 207.623Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M190.293 211.114C190.293 211.114 174.089 202.023 158.437 211.114C142.785 220.206 158.437 229.458 158.437 229.458C158.437 229.458 174.642 238.389 190.293 229.297C205.945 220.206 190.293 211.114 190.293 211.114Z",
    fill: "#2175B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M197.252 220.181V214.717H151.482V220.228L197.252 220.181Z",
    fill: "#2175B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M190.293 205.603C190.293 205.603 174.089 196.512 158.437 205.603C142.785 214.695 158.437 223.947 158.437 223.947C158.437 223.947 174.642 232.878 190.293 223.786C205.945 214.695 190.293 205.603 190.293 205.603Z",
    fill: "#5FA9E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M162.158 185.781H186.574V213.562H186.546C186.623 215.042 185.759 216.72 182.862 218.402C180.243 219.777 177.332 220.503 174.373 220.518C171.415 220.533 168.497 219.836 165.864 218.488C165.864 218.488 162.322 216.376 162.18 213.562H162.158L162.158 185.781Z",
    fill: "#2584CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M156.157 181.789H156.869C158.052 179.918 159.718 178.401 161.692 177.399C174.146 170.165 187.04 177.399 187.04 177.399C188.871 178.51 190.437 180.009 191.629 181.789H192.575V184.65H192.566C192.677 186.856 191.355 189.361 187.04 191.868C183.134 193.918 178.793 195 174.382 195.022C169.97 195.044 165.618 194.006 161.692 191.995C161.692 191.995 156.374 188.849 156.166 184.65H156.157V181.789Z",
    fill: "#2175B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M187.04 174.539C187.04 174.539 174.146 167.305 161.692 174.539C149.238 181.773 161.692 189.135 161.692 189.135C165.618 191.146 169.97 192.184 174.381 192.161C178.793 192.139 183.134 191.058 187.04 189.007C199.494 181.773 187.04 174.539 187.04 174.539Z",
    fill: "#5FA9E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M161.896 152.402H186.313V180.183H186.284C186.361 181.663 185.497 183.34 182.6 185.023C179.981 186.398 177.07 187.123 174.112 187.138C171.153 187.153 168.235 186.457 165.602 185.109C165.602 185.109 162.061 182.997 161.918 180.183H161.896L161.896 152.402Z",
    fill: "#2584CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M156.542 153.36H157.255C158.437 151.489 160.104 149.972 162.078 148.97C174.531 141.736 187.426 148.97 187.426 148.97C189.257 150.081 190.823 151.58 192.014 153.36H192.961V156.221H192.952C193.062 158.427 191.74 160.932 187.426 163.439C183.52 165.489 179.178 166.571 174.767 166.593C170.356 166.615 166.004 165.577 162.078 163.566C162.078 163.566 156.76 160.42 156.551 156.221H156.542V153.36Z",
    fill: "#2175B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M156.157 152.493L156.161 152.433C156.151 152.093 156.175 151.753 156.233 151.418C157.046 136.224 174.366 136.435 174.366 136.435C176.625 136.25 178.898 136.523 181.05 137.237C183.201 137.951 185.186 139.091 186.886 140.591C188.586 142.09 189.966 143.917 190.944 145.962C191.921 148.007 192.476 150.228 192.575 152.493H192.566C192.677 154.698 191.355 157.204 187.039 159.71C183.134 161.761 178.792 162.843 174.381 162.865C169.97 162.887 165.618 161.849 161.692 159.838C161.692 159.838 156.373 156.692 156.165 152.493H156.157Z",
    fill: "#2584CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M179.484 137.734C177.904 136.908 176.148 136.476 174.366 136.476C172.583 136.476 170.827 136.908 169.247 137.734C164.218 140.656 169.247 143.629 169.247 143.629C170.833 144.441 172.59 144.86 174.372 144.851C176.153 144.842 177.907 144.405 179.484 143.577C184.513 140.656 179.484 137.734 179.484 137.734Z",
    fill: "#5FA9E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M173.052 178.958C173.257 176.775 172.921 174.575 172.075 172.553C171.228 170.53 169.898 168.747 168.2 167.36C167.595 166.884 166.902 166.533 166.16 166.328C165.419 166.123 164.643 166.068 163.88 166.166L163.879 166.162L163.843 166.178C163.698 166.225 163.557 166.286 163.423 166.359L146.136 174.207L151.595 191.507L170.89 182.89L170.889 182.887C171.889 182.478 172.744 181.371 173.052 178.958Z",
    fill: "#2584CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M151.018 175.732C152.506 177.343 153.574 179.296 154.129 181.418C154.684 183.54 154.709 185.767 154.201 187.901C152.282 194.907 147.179 189.743 147.179 189.743C145.678 188.151 144.599 186.207 144.041 184.09C143.482 181.973 143.462 179.749 143.982 177.622C145.917 170.561 151.018 175.732 151.018 175.732Z",
    fill: "#2175B5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Baustrom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 342",
    d: "M222.081 254.072L227.694 210.296L225.126 208.349L219.513 252.124L222.081 254.072Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 345",
    d: "M233.694 246.411L228.081 202.636L230.649 200.689L236.325 245.21L233.694 246.411Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 337",
    d: "M219.518 173.839L257.789 195.819V254.881L219.518 232.901V173.839Z",
    fill: "#D27735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 340",
    d: "M219.518 252.035L257.789 274.015L257.682 276.699L219.518 255.257V252.035Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 341",
    d: "M257.686 276.637L263.298 232.862L260.731 230.915L255.118 274.69L257.686 276.637Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 343",
    d: "M271.889 268.414L266.277 224.639L268.845 222.691L274.457 266.467L271.889 268.414Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 344",
    d: "M233.649 243.212L271.92 265.192V268.414L233.649 246.434V243.212Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 339",
    d: "M238.695 162.814L276.965 184.794L257.789 195.841L219.518 173.861L238.695 162.814Z",
    fill: "#E08645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 338",
    d: "M276.963 184.796L257.686 195.819V254.881L276.963 243.858V184.796Z",
    fill: "#A95D25"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 64",
    rx: 11.4138,
    ry: 10.0809,
    transform: "matrix(-0.759553 -0.650446 -0.364355 0.93126 238.91 204.014)",
    fill: "#D4030A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 346",
    d: "M232.698 214.914L243.946 211.339V215.513L232.698 219.088V214.914Z",
    fill: "#D4030A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 347",
    d: "M232.672 199.375L223.96 206.868V202.694L231.794 194.054L232.672 199.375Z",
    fill: "#D4030A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 65",
    rx: 8.65421,
    ry: 7.64358,
    transform: "matrix(-0.759553 -0.650446 -0.364355 0.93126 229.346 210.232)",
    fill: "#9C0005"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 348",
    d: "M199.786 279.735C199.786 279.735 193.928 248.274 202.327 230.659C208.028 218.701 228.538 209.125 228.538 209.125C228.538 209.125 229.703 209.125 229.793 211.288C229.884 213.451 228.538 213.494 228.538 213.494C228.538 213.494 210.662 222.008 205.22 231.416C195.715 247.847 203.146 278.881 203.146 278.881C203.146 278.881 203.542 280.169 202.001 280.458C200.46 280.747 199.786 279.735 199.786 279.735Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot-bauversorgung",
    cx: 201.999,
    cy: 281.558,
    r: 4.20082,
    fill: "#B4005F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBauversorgung);
export default __webpack_public_path__ + "static/media/Bauversorgung.199d8a3880fb72f7e0c781c298f14deb.svg";
export { ForwardRef as ReactComponent };